<template>
    <div>
        <h1>{{$t('annualreport.title')}}</h1>
        <loader :loading="loading" :error="error">
            <div class="row flex">
                <div v-for="country in countries" class="flex__item flex--column col-xs-12">
                    <year-graph-widget  :key="country.id" :country="country" class="flex__item"/>
                </div>
            </div>
        </loader>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import YearGraphWidget from '../components/widgets/year-graph/YearGraphWidget';
    import Loader from '../components/general/Loader';
    import {COUNTRIES_GET} from '../store/modules/countries';

    @Component({
        components: {Loader, YearGraphWidget}
    })
    export default class AnnualReportPage extends Vue {
        created() {
            this.$store.dispatch(COUNTRIES_GET);
        }

        get countries() {
            return this.$store.state.countries.countries
                .filter(country => country.has_sales);
        }

        get loading() {
            return this.$store.state.countries.loading;
        }

        get error() {
            return this.$store.state.countries.errors.length > 0;
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/AnnualReportPage.vue